import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 22 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.42 15.813a1.41 1.41 0 0 0-1.004.42A1.454 1.454 0 0 0 0 17.25v1.438a4.34 4.34 0 0 0 1.247 3.049A4.23 4.23 0 0 0 4.258 23h13.484a4.23 4.23 0 0 0 3.01-1.263A4.34 4.34 0 0 0 22 18.687V17.25c0-.514-.27-.988-.71-1.245a1.404 1.404 0 0 0-1.419 0 1.44 1.44 0 0 0-.71 1.245v1.438c0 .38-.15.746-.416 1.016a1.41 1.41 0 0 1-1.003.42H4.258a1.41 1.41 0 0 1-1.003-.42 1.447 1.447 0 0 1-.416-1.017V17.25c0-.381-.15-.747-.416-1.016a1.41 1.41 0 0 0-1.003-.422Z",
      fill: "#0F0D37"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11 0a1.41 1.41 0 0 0-1.004.42 1.45 1.45 0 0 0-.416 1.017v10.544L7.451 9.825a1.461 1.461 0 0 0-1.87-.223 1.447 1.447 0 0 0-.195 2.2l3.42 3.456a3.088 3.088 0 0 0 2.195.92c.823 0 1.612-.331 2.195-.92l3.424-3.457a1.448 1.448 0 0 0-.195-2.199 1.462 1.462 0 0 0-1.87.223l-2.129 2.156V1.437c0-.382-.15-.749-.418-1.019A1.41 1.41 0 0 0 11 0Z",
      fill: "#0F0D37"
    }, null, -1)
  ]))]))
}
export default { render: render }